var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "3", md: "3" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    {
                      attrs: {
                        color: "primary",
                        dense: "",
                        dark: "",
                        flat: ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "extension",
                          fn: function() {
                            return [
                              _c(
                                "v-tabs",
                                {
                                  attrs: { "align-with-title": "" },
                                  model: {
                                    value: _vm.tab,
                                    callback: function($$v) {
                                      _vm.tab = $$v
                                    },
                                    expression: "tab"
                                  }
                                },
                                [
                                  _c("v-tab", [_vm._v("Single")]),
                                  _c("v-tab", [_vm._v("Multi")])
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [_c("span", [_vm._v("Create")])]
                  ),
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-tabs-items",
                        {
                          model: {
                            value: _vm.tab,
                            callback: function($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab"
                          }
                        },
                        [
                          _c(
                            "v-tab-item",
                            [
                              _c("create-rack", {
                                attrs: {
                                  "default-data": _vm.editRackEgg,
                                  "incubator-rack-list-items":
                                    _vm.incubatorRackList
                                },
                                on: {
                                  "update:defaultData": function($event) {
                                    _vm.editRackEgg = $event
                                  },
                                  "update:default-data": function($event) {
                                    _vm.editRackEgg = $event
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _c("create-many-rack", {
                                attrs: {
                                  "incubator-rack-list-items":
                                    _vm.incubatorRackList
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "3", md: "3" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    {
                      attrs: { color: "primary", dense: "", dark: "", flat: "" }
                    },
                    [_c("span", [_vm._v("List")])]
                  ),
                  _c(
                    "v-container",
                    [
                      _c("table-rack", {
                        on: { edit: item => (_vm.editRackEgg = item) }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }